/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { RequestType } from '../data/types.generated';
import { IHost } from '../hosts/IHost';
import { EntryPoint } from '../logger/interfaces';
import { ApprovalCreator, ApprovalType } from '../service/gen/esign';

export const ApprovalTypeToString = (approvalType: ApprovalType): string => {
    switch (approvalType) {
        case ApprovalType.ESign: {
            return 'ESign';
        }
        case ApprovalType.Basic: {
            return 'Basic';
        }
        case ApprovalType.Templated: {
            return 'Templated';
        }
        default: {
            return 'Basic';
        }
    }
};

export function getApprovalCreator(entryPoint: EntryPoint, host: IHost): ApprovalCreator {
    if (entryPoint === EntryPoint.PersonalApp) return ApprovalCreator.PersonalApp;
    else if (entryPoint === EntryPoint.OfficeAddinCommand || entryPoint === EntryPoint.OfficeAddinRibbon) {
        return ApprovalCreator.WordAddIn;
    } else {
        if (host.isChatContext()) return ApprovalCreator.ChatMessage;
        else return ApprovalCreator.ChannelPost;
    }
}

export const NumberToRequestType = (requestTypeNumber: number): RequestType => {
    switch (requestTypeNumber) {
        case 0: {
            return RequestType.NotSpecified;
        }
        case 1: {
            return RequestType.Other;
        }
        case 2: {
            return RequestType.Basic;
        }
        case 3: {
            return RequestType.Esign;
        }
        case 4: {
            return RequestType.Templates;
        }
        default: {
            return RequestType.NotSpecified;
        }
    }
};
